export default __webpack_public_path__ + "static/media/logo-louis-belet.f97c4003.svg";